import React from "react";

const Bash_Data_Types = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Data Types</h2>
      <p>Bash treats data as strings. Arrays exist, but there's no strict typing like other languages. Numbers are manipulated using tools like <code>expr</code> or arithmetic expansion.</p>
    </div>
  );
};

export default Bash_Data_Types;
